import type { RouteRecordRaw } from 'vue-router';

export const issuesRoute: RouteRecordRaw = {
  path: '/issues',
  name: 'Issues',
  component: () => import('./pages/IssuesPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:issues:list'),
  },
};

/**
 * The calendar is the board's second view, so it is the board's page under a
 * second address — the router keeps the page mounted between the two, and the
 * search and the chips with it.
 *
 * `/issues/calendar` cannot be mistaken for a task: the task route below takes
 * digits only (`:number(\d+)`), so «calendar» never matches it — whichever of
 * the two is registered first.
 */
export const issuesCalendarRoute: RouteRecordRaw = {
  path: '/issues/calendar',
  name: 'IssuesCalendar',
  component: () => import('./pages/IssuesPage.vue'),
  meta: {
    layout: 'main',
    // The same tasks, seen by the same people as the board.
    authorize: ({ isGranted }) => isGranted('ugi:core:issues:list'),
  },
};

/**
 * `/issues/archive` cannot be mistaken for a task: the task route below takes
 * digits only (`:number(\d+)`), so «archive» never matches it — whichever of
 * the two is registered first.
 */
export const issuesArchiveRoute: RouteRecordRaw = {
  path: '/issues/archive',
  name: 'IssuesArchive',
  component: () => import('./pages/IssuesArchivePage.vue'),
  meta: {
    layout: 'main',
    // The archive is the same tasks, seen by the same people as the board.
    authorize: ({ isGranted }) => isGranted('ugi:core:issues:list'),
  },
};

export const issueRoute: RouteRecordRaw = {
  path: '/issues/:number(\\d+)',
  name: 'Issue',
  component: () => import('./pages/IssuePage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:issues:get'),
  },
};
